import { render, staticRenderFns } from "./ObiText.vue?vue&type=template&id=f0c07d32&scoped=true&"
import script from "./ObiText.vue?vue&type=script&lang=js&"
export * from "./ObiText.vue?vue&type=script&lang=js&"
import style0 from "./ObiText.vue?vue&type=style&index=0&id=f0c07d32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c07d32",
  null
  
)

export default component.exports